// extracted by mini-css-extract-plugin
module.exports = {"wholeHome":"WholeHome_wholeHome___dsKv"};